<template><div><h1 id="_1-adressbereinigung-manuell" tabindex="-1"><a class="header-anchor" href="#_1-adressbereinigung-manuell"><span>1. Adressbereinigung (manuell)</span></a></h1>
<p>Systematische manuelle Bereinigungen von Personendaten können mittels einer speziell dafür vorgesehener Ansicht komfortabel abgearbeitet werden. Die zu bereinigenden Personen können bequem in einem Filter selektiert und den entsprechenden Benutzern zugeteilt werden. Sowohl die Benutzer als auch der Adminstrator hat jederzeit den Überblick wieviele Daten bearbeitet und wieviele noch zu bearbeiten sind.</p>
<h2 id="_1-1-administrator-ansicht" tabindex="-1"><a class="header-anchor" href="#_1-1-administrator-ansicht"><span>1.1. Administrator-Ansicht</span></a></h2>
<p>Die Zuteilung der zu bearbeitenden Daten (Personen) erfolgt über die Administrator-Ansicht, zu finden im Menu Personen/Datenpflege/Bearbeitung manuell/Manuelle Bereinigung (Administrator). Vorgängig müssen die Personen in einem Filter selektiert werden.</p>
<p><strong>Prozedur 2.1. Selektion und Zuteilung der Personen</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für die Zuteilung der Personen muss vorgängig ein Filter definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für die Zuteilung markiert sein.</p>
</li>
<li>
<p>Zuteilung in der Administrator-Ansicht</p>
<p>In der Administrator-Ansicht den definierten Filter auswählen.</p>
</li>
<li>
<p>Benutzer zuordnen</p>
<p>Zum ausgewählten Filter die Benutzer für die Bereinigung zuteilen und die Anzahl zu bearbeitenden Datensätze unter &quot;zugeteilt&quot; eingeben.</p>
</li>
</ol>
<h2 id="_1-2-benutzer-ansicht" tabindex="-1"><a class="header-anchor" href="#_1-2-benutzer-ansicht"><span>1.2. Benutzer-Ansicht</span></a></h2>
<p>Die zugeteilten Personen werden dem Benutzer in der Ansicht Personen/Datenpflege/Bearbeitung manuell/Manuelle Bereinigung angezeigt. Der Benutzer sieht alle ihm zugeteilten Filter mit der zu bereinigenden Anzahl und die gesamte zu bereinigende Anzahl (Gruppe, inkl. alle anderen Benutzern).</p>
<p><strong>Prozedur 2.2. Bereinigung</strong></p>
<ol>
<li>
<p>Filter auswählen</p>
<p>Zuoberst im Frame Personenbereinigung kann der gewünschte Filter für die Bereinigung ausgewählt werden.</p>
</li>
<li>
<p>Person Anzeige/Selektion</p>
<p>Die Personen im Filter werden im Frame Personen angezeigt und können in beliebiger Reihenfolge für die Bereinigung selektiert werden.</p>
</li>
<li>
<p>Kontrolle/Bereinigung</p>
<p>Im Frame Person können die Daten geprüft und bei Bedarf mutiert werden.</p>
</li>
<li>
<p>Als bearbeitet markieren</p>
<p>Wenn die Prüfung/Bereinigung des Datensatzes vorgenommen wurde, kann dieser mit der Checkbox als bearbeitet markiert werden.</p>
</li>
</ol>
<h2 id="_1-3-siehe-auch" tabindex="-1"><a class="header-anchor" href="#_1-3-siehe-auch"><span>1.3. Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adressbereinigunguser.html" title="Adressbereinigung">Adressen manuell bereinigen</RouteLink></p>
<p><RouteLink to="/referenz/refs/ft.refdata.adressbereinigungadmin.html" title="Adressbereinigung (Administrator)">Adressbereinigung (Administrator)</RouteLink></p>
</div></template>


